import { Box } from "@mui/material"

export const CanIGetHelp = () => {
    return (<>
        <Box className="WELCOME_slide">
            <Box className="WELCOME_about">
                <Box>
                    <h1>Can I Get Help</h1>
                </Box>
            </Box>
        </Box>
    </>)
}